import { render } from "./DataTablePanel.vue?vue&type=template&id=38c0267a"
import script from "./DataTablePanel.vue?vue&type=script&lang=js"
export * from "./DataTablePanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__